export const EVENT_GIFT = 'EVENT_GIFT';
export const EVENT_AUTH = 'EVENT_AUTH';
